import { api } from "../../api"

export async function loadLibrary(): Promise<MediaLibrary[]> {
    let lib = await api<MediaLibrary[]>("medialib", {})
    return lib.data
}
